export const TS_EMAIL = 'TS_EMAIL';
export const TS_PASS = 'TS_PASS';
export const TS_EMAIL_VERIFY = 'TS_EMAIL_VERIFY';
export const TS_PASS_VERIFY = 'TS_PASS_VERIFY';
// / FIREBASE AUTH ACTIONS
export const LOGIN_WITH_PROVIDER_FIREBASE = 'LOGIN_WITH_PROVIDER_FIREBASE';
export const REGISTER_FIREBASE_USER = 'REGISTER_FIREBASE_USER';
export const LOGIN_FIREBASE_USER = 'LOGIN_FIREBASE_USER';
export const FETCH_FIREBASE_USER = 'FETCH_FIREBASE_USER';
export const UPDATE_FIREBASE_USER = 'UPDATE_FIREBASE_USER';
export const CHANGE_FIREBASE_USER_PASSWORD = 'CHANGE_FIREBASE_USER_PASSWORD';
export const FIREBASE_PASSWORD_RESET_EMAIL = 'FIREBASE_PASSWORD_RESET_EMAIL';
export const LOGOUT_FIREBASE_USER = 'LOGOUT_FIREBASE_USER';
export const SEND_EMAIL_VERIFICATION = 'SEND_EMAIL_VERIFICATION';
// Overlay
export const CHANGE_COLOR = 'CHANGE_COLOR';
export const CLEAR_DRAW = 'CLEAR_DRAW';

// Map
export const CHANGE_MAP = 'CHANGE_MAP';

// Map
export const CHANGE_STAMP = 'CHANGE_STAMP';

// Canvas
export const UPDATE_CANVAS = 'UPDATE_CANVAS';

// Modal
export const UPDATE_MODAL = 'UPDATE_MODAL';

export const GET_USER_DATA = 'GET_USER_DATA';

export const SET_ACTIVE = 'SET_ACTIVE';



// WEBPACK FOOTER //
// ./src/app/actions/types.js